import * as S from './styles';

interface Props {
  titulo: string;
  descricao: string;
  infoImage: string;
  imageHeight?: string;
}

function AuthInfo ({ infoImage, imageHeight, titulo, descricao }: Props) {
  return (
    <S.Container>
      <S.TextContainer >
        <S.Title>{titulo}</S.Title>
        <S.Description>{descricao}</S.Description>
      </S.TextContainer>
      <S.Image $imageHeight={imageHeight} src={infoImage} alt="infoImage" />
    </S.Container>
  );
}

export default AuthInfo;